import React from 'react';
import PropTypes from 'prop-types';
import Link, { LINK_BEHAVIORS } from 'components/Link';
import ResponsiveImage from 'components/ResponsiveImage';
import Anchor from 'components/Anchor';
import { breakpoints } from 'js/breakpoints';
import fallbackImageSrc from '../../assets/image-placeholder-light.svg';
import './PrioritizedMarketsBlock.scss';

const PrioritizedMarketsBlock = ({
  heading,
  headingTagLevel = 3,
  intro,
  link,
  image,
  anchor,
}) => {
  const HeadingTag = `h${headingTagLevel}`;
  const fallbackImage = {
    src: fallbackImageSrc,
  };

  return (
    <article className="prioritized-markets-block">
      <div className="prioritized-markets-block__card card">
        <div className="prioritized-markets-block__text-content content">
          <header>
            {heading && (
              <HeadingTag className="prioritized-markets-block__heading">
                {anchor && <Anchor {...anchor} />}
                {heading}
              </HeadingTag>
            )}
            {intro && (
              <div
                className="prioritized-markets-block__intro intro wysiwyg typo-small"
                dangerouslySetInnerHTML={{
                  __html: intro.stripHtmlTags(),
                }}
              />
            )}
            {link && (
              <Link
                {...link}
                className="prioritized-markets-block__link"
                behavior={LINK_BEHAVIORS.card}
              />
            )}
          </header>
        </div>
        <div className="image prioritized-markets-block__image">
          <ResponsiveImage
            {...(image ?? fallbackImage)}
            className="responsive-image_size_prioritized-markets-block"
            loading="lazy"
            sources={[
              {
                width: 100,
                height: 136,
                media: breakpoints.m,
              },
              {
                width: 660,
                height: 477,
                // Note: Image is scaling according to design up to the screen width 1440px
                media: 1440,
              },
            ]}
          />
        </div>
      </div>
    </article>
  );
};

PrioritizedMarketsBlock.propTypes = {
  anchor: PropTypes.exact(Anchor.propTypes),
  heading: PropTypes.string,
  headingTagLevel: PropTypes.oneOf([2, 3]),
  intro: PropTypes.string,
  link: PropTypes.exact(Link.propTypes),
  image: PropTypes.exact(ResponsiveImage.propTypes),
};

export default PrioritizedMarketsBlock;
